import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetCanadianPayrollBusinessEntityRequest,
  TGetCanadianPayrollBusinessEntityResponse,
} from "./getCanadianPayrollBusinessEntity.schema";

export const getCanadianPayrollBusinessEntity = (axios: IAxiosInstance) => {
  return async (
    params: TGetCanadianPayrollBusinessEntityRequest
  ): Promise<TGetCanadianPayrollBusinessEntityResponse> => {
    const response = await axios.noRetry.get<
      ZealApiResponse<TGetCanadianPayrollBusinessEntityResponse>
    >("/api/canadian-payroll/business-entity", {
      params,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
